<template>
  <TitleFrame text="ユーザ設定">
    <template slot="contents">
      <InputUserSettings v-if="qid===0" :is-test=isTest @click-ok="onClickOkSettings" />
      <InputConsider v-if="qid===1" @select-text="onSelectConsider" />
      <InputLate v-if="qid===2" @select-text="onSelectLate" />
    </template>
  </TitleFrame>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import InputUserSettings from '@/components/Organisms/InputUserSettings'
import InputConsider from '@/components/Organisms/InputConsider'
import InputLate from '@/components/Organisms/InputLate'
import Firebase from './../../firebase'

export default {
  name: 'settings',
  components: {
    TitleFrame,
    InputUserSettings,
    InputConsider,
    InputLate
  },
  computed: {
    ...mapState(['isTest', 'isAgreed', 'isAnswered', 'uid']),
    coockieUid () {
      return this.$cookies.get('uid')
    }

  },
  data () {
    return {
      qid: 0,
      ans: {
        settings: {},
        consider: '',
        late: ''
      },
      settings: {},
      consider: '',
      late: ''
    }
  },
  methods: {
    ...mapMutations(['loadingStart', 'loadingEnd']),
    onClickOkSettings (e) {
      this.ans.settings = e
      this.qid = 1
    },
    onSelectConsider (e) {
      this.ans.consider = e
      this.qid = 2
    },
    onSelectLate (e) {
      this.ans.late = e
      Firebase.putAnswers(this.ans)
    }
  },
  watch: {
    isAnswered: {
      immideate: true,
      handler: function () {
        if (this.isAnswered) {
          // 回答済みならば実験参加画面へ
          this.$router.push({name: 'ExperimentAgree'})
        } else {
          // 未回答ならば回答画面を表示する
          this.loadingEnd()
        }
      }
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (this.isAnswered) {
      // 回答済みならば実験参加画面へ
      this.$router.push({name: 'ExperimentAgree'})
    } else {
      Firebase.getAnswersExist(this.ans)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';

</style>



// WEBPACK FOOTER //
// src/components/Pages/Settings.vue